// 用户认证相关
import * as Auth from './auth';
// 用户中心相关
import * as Account from './account';
// 商店充值相关
import * as Store from './store';

export default {
    Auth,
    Account,
    Store
}